import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../core/auth/auth.service';
import { DashboardWidget } from '../../../../viewmodels/dashboard/dashboard-widget';
import { ViewDataTableService } from '../view-data-widget/view-data-table.service';
import { WidgetDataType } from '../widget-data-type';
import { WidgetParametersService } from '../widget-parameters/widget-parameters.service';
import { AssetCountItemizedWidgetData } from './asset-count-itemized-widget-data';
import { CompletedReportItemizedWidgetData } from './completed-report-itemized-widget-data';
import { HighRiskItemsItemizedWidgetData } from './high-risk-items-itemized-widget-data';
import { ItemizedWidgetData } from './itemized-widget-data';
import { MitigationsDueByMonthItemizedWidgetData } from './mitigations-due-by-month-itemized-widget-data';
import { MitigationsDueItemizedWidgetData } from './mitigations-due-itemized-widget-data';
import { OverdueMitigationItemizedWidgetData } from './overdue-mitigation-itemized-widget-data';
import { PlannedMaintenanceDistributionItemizedWidgetData } from './planned-maintenance-distribution-itemized-widget-data';
import { PlannedMaintenanceImprovementsItemizedWidgetData } from './planned-maintenance-improvements-itemized-widget-data';
import { RiskDistributionItemizedWidgetData } from './risk-distribution-itemized-widget-data';
@Injectable({
  providedIn: 'root',
})
export class ItemizedWidgetDataFactory {
  constructor(private viewDataTableService: ViewDataTableService, private router: Router, private widgetParametersService: WidgetParametersService, private authService: AuthService) { }

  public createItemizedWidgetDataClass(dashboardWidget: DashboardWidget): ItemizedWidgetData {
    switch (dashboardWidget.widget.widgetDataType) {
      case WidgetDataType.PlannedMaintenanceImprovements:
        return new PlannedMaintenanceImprovementsItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.OverdueMitigations:
        return new OverdueMitigationItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.MitigationsDue:
        return new MitigationsDueItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.AssetCount:
        return new AssetCountItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.PlannedMaintenanceDistribution:
        return new PlannedMaintenanceDistributionItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.HighRiskItems:
        return new HighRiskItemsItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.MitigationsDueByMonth:
        return new MitigationsDueByMonthItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.CompletedReports:
        return new CompletedReportItemizedWidgetData(this.viewDataTableService, this.router, this.authService);
      case WidgetDataType.RiskDistribution:
        const riskDistribution = this.widgetParametersService.getRiskDistributionParameter(dashboardWidget);
        return new RiskDistributionItemizedWidgetData(this.viewDataTableService, this.router, riskDistribution, this.authService);
      default:
        return null;
    }
  }
}
